// Import the functions you need from the SDKs you need
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/firebase-messaging'
// import { Messaging } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCAadQds5PW2AGCVuPFdES957Xi0e9zbcA",
  authDomain: "lapar-279207.firebaseapp.com",
  databaseURL: "https://lapar-279207.firebaseio.com",
  projectId: "lapar-279207",
  storageBucket: "lapar-279207.appspot.com",
  messagingSenderId: "892705321352",
  appId: "1:892705321352:web:91a7d90811853a302e4a3d",
  measurementId: "G-DGYSGFB65N"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
// let messaging = null;
// if (firebase.messaging.isSupported()){
//   messaging = firebase.messaging();
// }
// const firebase_messaging=messaging;
export default firebase;

